export enum AidFrontendDynamicConfig {
  // https://console.statsig.com/LqivKg6ADZZaGczRfBKfX/dynamic_configs/aid-frontend_disabled_cobranding_application_keys
  DISABLED_COBRANDING_APPLICATION_KEYS = 'aid-frontend_disabled_cobranding_application_keys',
}
